/* Life Milestone Planner — Ch. 25.
   Personalised roadmap from current age → 18 → 21 → 25 → 30. Checklists saved in URL. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  var MILESTONES = [
    { age: 18, title: 'At 18',
      change: 'Can open your own accounts, file your own taxes, and start a Roth IRA if you’re earning.',
      priorities: ['Open a checking account in your name', 'Open a high-yield savings account', 'File taxes for the first time (if working)', 'Start a $500 emergency-fund goal', 'Invest $25/month into a broad index fund'],
      mistakes: ['Ignoring taxes — missing refunds', 'Taking on credit-card debt immediately', 'Not investing because "amounts are too small"'],
      checklist: ['Open checking account', 'Open high-yield savings account', 'Build a credit history (secured card or authorised user)', 'Set up direct deposit'] },

    { age: 21, title: 'At 21',
      change: 'Full legal adulthood. More credit products available. You can be on your own lease.',
      priorities: ['Complete a 3-month emergency fund', 'Roth IRA contributing $50+/month', 'Zero high-interest credit-card debt', 'Begin tracking net worth quarterly'],
      mistakes: ['Lifestyle inflation when income rises', 'Ignoring student-loan interest accruing', 'No investment account at all'],
      checklist: ['Open a Roth IRA', 'Auto-transfer to investing each payday', 'Pay off any credit-card balance in full monthly', 'Get renter’s insurance if leasing'] },

    { age: 25, title: 'At 25',
      change: 'Career income growing. First "real" financial decisions begin.',
      priorities: ['6-month emergency fund', '$10k+ invested', 'FIRE number calculated and tracked', 'Retirement contributing 15% of income'],
      mistakes: ['No insurance gaps check (health, disability)', 'No will or named beneficiaries', 'Comparing net worth to peers on social media'],
      checklist: ['Calculate your FIRE number', 'Increase 401(k) to employer match minimum', 'Get a term life-insurance quote (if dependants)', 'Designate beneficiaries on every account'] },

    { age: 30, title: 'At 30',
      change: 'Higher income, clearer career trajectory, possibly family.',
      priorities: ['Net worth positive and growing yearly', 'Retirement on track (10× annual salary by 67 trajectory)', 'Passive income starting (dividends, side income)', 'Written 10-year financial plan'],
      mistakes: ['No 10-year plan written', 'Insurance gaps remain', 'Career stagnation without a financial cushion to pivot'],
      checklist: ['Write a 1-page 10-year plan', 'Refinance any debt above 6% APR', 'Maximise tax-advantaged accounts', 'Build one income stream outside your day job'] }
  ];

  class MilestonePlanner {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.state = {
        age: +u.age || 17,
        delay: +u.delay || 3,
        checks: u.checks ? JSON.parse(decodeURIComponent(u.checks)) : {}
      };
      this.render(); this.bind(); this.update();
    }
    render() {
      var s = this.state;
      this.el.innerHTML = `
        <div class="sim-controls" style="display:grid; grid-template-columns:1fr 1fr; gap:24px; margin-bottom:24px;">
          <div class="sim-field">
            <label class="sim-field__label"><span>Your current age</span><span class="val" data-display="age">${s.age}</span></label>
            <input type="range" data-state="age" min="13" max="30" step="1" value="${s.age}">
          </div>
          <div class="sim-field">
            <label class="sim-field__label"><span>Compare with starting in (years)</span><span class="val" data-display="delay">${s.delay} yr</span></label>
            <input type="range" data-state="delay" min="1" max="10" step="1" value="${s.delay}">
          </div>
        </div>

        <div class="sim-insight" data-out="comparison"></div>

        <div data-out="timeline" style="display:grid; grid-template-columns:repeat(4,1fr); gap:16px; margin-top:24px;"></div>
      `;
      // tighten timeline grid on mobile
      var t = this.el.querySelector('[data-out="timeline"]');
      var media = window.matchMedia('(max-width: 800px)');
      function adapt() { t.style.gridTemplateColumns = media.matches ? '1fr' : 'repeat(4, 1fr)'; }
      adapt(); media.addEventListener('change', adapt);
    }
    bind() {
      this.el.querySelectorAll('input[data-state]').forEach(input => {
        input.addEventListener('input', () => {
          var k = input.dataset.state, v = +input.value;
          this.state[k] = v;
          var l = this.el.querySelector(`[data-display="${k}"]`);
          if (l) l.textContent = (k === 'delay') ? v + ' yr' : v;
          this.update();
        });
      });
      this.el.addEventListener('change', e => {
        if (e.target.matches('[data-check]')) {
          var key = e.target.dataset.check;
          this.state.checks[key] = e.target.checked;
          this.update();
        }
      });
    }
    update() {
      var s = this.state;
      // Comparison: $200/mo at 8% to age 30
      var fv = (years) => {
        if (years <= 0) return 0;
        var r = 0.08 / 12, n = years * 12;
        return 200 * ((Math.pow(1 + r, n) - 1) / r);
      };
      var nowYears   = Math.max(0, 30 - s.age);
      var laterYears = Math.max(0, 30 - s.age - s.delay);
      var diff = fv(nowYears) - fv(laterYears);
      this.el.querySelector('[data-out="comparison"]').innerHTML =
        `Investing $200/month at 8% — starting now vs. starting in ${s.delay} years means a <strong>${fmt(diff)}</strong> difference at age 30.`;

      var tl = this.el.querySelector('[data-out="timeline"]');
      tl.innerHTML = MILESTONES.map(m => {
        var passed = m.age < s.age;
        return `
          <div class="card" style="border-color: ${passed ? 'var(--border)' : 'var(--yellow)'}; opacity:${passed ? 0.55 : 1};">
            <span class="pill" style="${passed ? 'background:var(--bg-raised); color:var(--text-secondary);' : ''}">AGE ${m.age}</span>
            <h3 style="margin:0;">${m.title}</h3>
            <p class="sim-result__sub" style="margin:0;">${m.change}</p>
            <p class="label">PRIORITIES</p>
            <ol style="margin:0; padding-left:18px; font-size:14px; color:var(--ink-mid);">
              ${m.priorities.map(p => `<li>${p}</li>`).join('')}
            </ol>
            <p class="label" style="color:var(--yellow-hover);">AVOID THESE</p>
            <ul style="margin:0; padding-left:18px; font-size:14px; color:var(--ink-mid);">
              ${m.mistakes.map(p => `<li>${p}</li>`).join('')}
            </ul>
            <p class="label">CHECKLIST</p>
            <div>${m.checklist.map((c, i) => {
              var key = m.age + ':' + i;
              return `<label style="display:flex; gap:8px; align-items:flex-start; font-size:14px; padding:4px 0;">
                <input type="checkbox" data-check="${key}" ${this.state.checks[key] ? 'checked' : ''}>
                <span>${c}</span>
              </label>`;
            }).join('')}</div>
          </div>`;
      }).join('');

      IT.url.write({ age: s.age, delay: s.delay, checks: encodeURIComponent(JSON.stringify(s.checks)) });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new MilestonePlanner('simulator-container'));
})();
